export type Logger = {
  error: (message: string, ...optionalParams: unknown[]) => void;
};

/**
 * Format an unknown error object for logging.
 */
export const formatError = (error: unknown): string => {
  if (error instanceof Error) {
    return String(error.stack);
  } else {
    return String(error);
  }
};
